import React, { useEffect, useState } from "react";
import axios from "axios";

const AnalyticsDashboard = () => {
    const [analytics, setAnalytics] = useState([]);

    useEffect(() => {
        axios.get("https://agpipefitting.org.et/admin/analytics")
            .then((response) => setAnalytics(response.data))
            .catch((error) => console.error("Error fetching analytics:", error));
    }, []);

    return (
        <div>
            <h2>Website Analytics</h2>
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Visitors</th>
                        <th>Page Views</th>
                    </tr>
                </thead>
                <tbody>
                    {analytics.map((data, index) => (
                        <tr key={index}>
                            <td>{data.date}</td>
                            <td>{data.visitors}</td>
                            <td>{data.pageViews}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AnalyticsDashboard;
